// ACTION TYPES
export const Types = {
  TRIGGER: 'PROJECTS/TRIGGER',
  REQUEST: 'PROJECTS/REQUEST',
  ERROR: 'PROJECTS/ERROR',
  SUCCESS: 'PROJECTS/SUCCESS',
  FULFILL: 'PROJECTS/FULFILL',
  TRIGGER_PROJECT: 'PROJECTS/TRIGGER_PROJECT',
  TRIGGER_ASSOCIATIS: 'PROJECTS/TRIGGER_ASSOCIATIS',
};

// INITIAL STATE
const initialState = {
  loading: false,
  error: '',
  projects: [],
  project: {
    main_image: {},
    gallery: [],
  },
  currentFilter: '',
};

// REDUCER
export default (state = initialState, action) => {
  switch (action.type) {
    case Types.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case Types.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case Types.FULFILL:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

// ACTIONS
export const trigger = () => {
  return {
    type: Types.TRIGGER,
  };
};

export const triggerProject = (codename) => {
  return {
    type: Types.TRIGGER_PROJECT,
    payload: codename,
  };
};

export const request = () => {
  return {
    type: Types.REQUEST,
  };
};

export const fulfill = () => {
  return {
    type: Types.FULFILL,
  };
};

export const failed = (error) => {
  return {
    type: Types.ERROR,
    payload: error,
  };
};

export const success = (payload) => {
  return {
    type: Types.SUCCESS,
    payload,
  };
};
